import styles from '~/styles/wrapper/view/view.module.scss'
import { ChildProps } from '~/common/define/props'

export enum Device {
  PC,
  SP
}

interface Props extends ChildProps {
  hide?: Device
  center?: Device
}

const DeviceView = ({children, hide = null, center = null}: Props) => {
  const hideClass = hide == Device.PC ? styles.sp : hide == Device.SP ? styles.pc : null
  const centerClass = center == Device.PC ? styles.center__pc : center == Device.SP ? styles.center__sp : ''
  return (
    <div className={hideClass ?? centerClass}>
      {children}
    </div>
  )
}

export default DeviceView